/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorAdunit from 'base/components/labrador/Adunit';

export const DynamicLabradorAdunit: typeof LabradorAdunit = (props) => {
    return <ErrorBoundary><LabradorAdunit {...props} /></ErrorBoundary>;
}
export type DynamicLabradorAdunitProps = PropsFromComponent<typeof LabradorAdunit>;
